var dataLayer;
/**
 * Lanza evento para grabar pagina 
 */
function setPageView(url, titulo, section, userId, entorno, proceso, periodicidad, marca, plan, monto){
    
  dataLayer.push ({
        'url': url ,  
        'titulo': titulo, 
        'canalBanco': 'supermovil',
        'subsection1': section ,
        'versionApp': '8.3.0',
        'userId':userId,
        'entorno': entorno,
        'proceso': proceso,
        'periodicidad': periodicidad,
        'marca': marca,
        'plan': plan,
        'monto': monto,
        'event': 'PageView'
      })
}

/**
 * Lanza evento detonado por accion de usuario
 */

 function setEvent(action, label, url, userID){
   
     dataLayer.push({
        'event': 'payments',
        'categoria': 'recarga_celular', 
        'accion':action, 
        'etiqueta':label,
        'canalBanco': 'supermovil',
        'url': url,
        'userID': userID
     });
 }


 /**
  * Set push  analitycs
  */

  function setPushEvent(folio, compania, monto,variante){
    dataLayer.push({
        'event':'purchaseComplete',
        'transactionId': folio,
        'transactionTotal': monto,
        'transactionProducts': [{
            'sku': folio,
            'name': 'TAE',
            'category': compania,
            'variant': variante,
            'brand':compania,
            'price': monto,
            'quantity': 1
         }]
    });
  }
